import { computed } from 'vue';
import { useFilters } from '@/composables/front/formatters/useFilters';

export function useAbonoCard(abono, detalle) {
    const { formatearPrecio, formatearFecha } = useFilters();

    const nombreCompleto = computed(() =>
        `${abono.value.name} ${abono.value.surnames}`
    );

    const iniciales = computed(() => {
        const name = abono.value.name || '';
        const surnames = abono.value.surnames || '';
        const initial1 = name.charAt(0).toUpperCase();
        const initial2 = surnames.charAt(0).toUpperCase();
        if (!initial1 && !initial2) return '';
        return initial1 + initial2;
    });

    const estaRenovado = computed(() => Boolean(
        detalle.value?.activo
            ?? detalle.value?.esta_renovado
            ?? abono.value.activo
            ?? abono.value.esta_renovado
    ));

    const renovacionAutomatica = computed(() =>
        detalle.value?.renovacion_automatica ?? abono.value.renovacion_automatica
    );

    const puedeDesmarcar = computed(() => Boolean(renovacionAutomatica.value));

    const asientoSrc = computed(() =>
        detalle.value?.asiento ?? detalle.value?.plaza ?? abono.value.asiento ?? abono.value.plaza ?? null
    );

    const plazaSrc = computed(() =>
        detalle.value?.plaza ?? abono.value.plaza
    );

    const asientoRegion = computed(() =>
        asientoSrc.value?.region?.nombre
            ?? plazaSrc.value?.region?.nombre
            ?? asientoSrc.value?.zona
            ?? null
    );

    const asientoFila = computed(() =>
        asientoSrc.value?.fila ?? asientoSrc.value?.row ?? plazaSrc.value?.fila ?? null
    );

    const asientoButaca = computed(() =>
        asientoSrc.value?.asiento
            ?? asientoSrc.value?.seat
            ?? asientoSrc.value?.numero
            ?? asientoSrc.value?.butaca
            ?? plazaSrc.value?.butaca
            ?? null
    );

    const descuentoDescripcion = computed(() => {
        const d = detalle.value?.descuento ?? abono.value.descuento;
        return d?.descripcion ?? 'Sin descuento';
    });

    const totalPrecio = computed(() => {
        const raw = detalle.value?.total_precio ?? abono.value.total_precio;
        return parseFloat(raw) || 0;
    });

    const totalPrecioFormateado = computed(() => formatearPrecio(totalPrecio.value));

    const fechaAntiguedad = computed(() =>
        formatearFecha(detalle.value?.fecha_antiguedad ?? abono.value.fecha_antiguedad) ?? '—'
    );

    const urlDescargar = computed(() =>
        detalle.value?.pdf_url
            ?? detalle.value?.url_descargar
            ?? abono.value.pdf_url
            ?? abono.value.url_descargar
            ?? null
    );

    const urlPassbook = computed(() =>
        detalle.value?.passbook_url
            ?? detalle.value?.url_passbook
            ?? abono.value.passbook_url
            ?? abono.value.url_passbook
            ?? null
    );

    const esTemporadaAnterior = computed(() =>
        abono.value.activo && !abono.value.activo_temporada_actual
    );

    const lfpId = computed(() =>
        detalle.value?.lfp_id ?? abono.value.lfp_id ?? null
    );

    return {
        nombreCompleto,
        iniciales,
        estaRenovado,
        esTemporadaAnterior,
        puedeDesmarcar,
        asientoRegion,
        asientoFila,
        asientoButaca,
        descuentoDescripcion,
        totalPrecioFormateado,
        fechaAntiguedad,
        urlDescargar,
        urlPassbook,
        lfpId,
    };
}
